import { RouteConfig } from 'vue-router';

export const confirmRoute: RouteConfig = {
  path: '/confirm/:token',
  name: 'confirm',
  component: () => import(/* webpackChunkName: "Confirm" */ '@/views/confirm/Confirm.vue')
};
